import { inject } from '@angular/core';
import { HttpEvent, HttpResponse, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { AsyncSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SpinnerModalService } from '../services/spinner-modal.service';
import { SpinnerPageService } from '../services/spinner-page.service';
import { ToastService } from '../services/toast.service';
import { ERROR_MESSAGES } from '../config/error_message.config';
import { toastConfig_error_common } from '../config/toast_message.config';

export const ErrorInterceptor: HttpInterceptorFn = (request, next) => {

  const toastService = inject(ToastService);
  const spinnerModalService = inject(SpinnerModalService);
  const spinnerPageService = inject(SpinnerPageService);
  const subject = new AsyncSubject<HttpEvent<any>>();

  next(request)
    .pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            subject.next(event);
            subject.complete();
          }
        },
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {

            let status = err.status;
            if (ERROR_MESSAGES[status]) {
              toastService.show({ ...toastConfig_error_common, text: ERROR_MESSAGES[status] });
              //Se non sono autorizzato nella chiamata whoiam esco dall'applicativo
              if (err.status == 401) {
                //(Utente non autenticato fare logout e da reindirizzare a login)
                console.log("Utente non autenticato fare logout e da reindirizzare a login");
              } else if (err.status == 403) {
                //(Utente autenticato ma che non è admin, da buttare su "Permesso negato")
                console.log("Utente autenticato ma che non è admin, da buttare su 'Permesso negato'");
              }
            } else {
              toastService.show({ ...toastConfig_error_common, text: err.error.message });
              console.warn(err);
            }
             
            spinnerPageService.forceStop();
            spinnerModalService.forceStop();
          }
          const errorEvent = new HttpErrorResponse(err);
          subject.error(errorEvent);
          subject.complete();
        }
      })).subscribe();
  return subject;
}